import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'split',
  pure: true
})
export class SplitPipe implements PipeTransform {

  transform(input: string, seperator: string = ',', trim: boolean = true): string[] {
    let parts = input?.split(seperator) || [];
    if(trim)
      parts.forEach(_ => _ = _.trim());
    return parts;
  }

}
